import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installTextStyleGuard } from "@/lib/textStyle";

// Suppress the benign "ResizeObserver loop" warning that Radix layout can trigger.
// It is harmless and dev-only, but CRA's overlay surfaces it intrusively.
const _roeRe = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e?.message && _roeRe.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

installTextStyleGuard();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
